import axios from "../lib/axios-config";
const draftInvoice = (payload)=>axios.put("/invoice/draft", payload);
const getInvoiceDetails = (id)=>axios.get("/invoice/details/".concat(id));
const getInvoices = (params)=>axios.get("/invoice", {
        params
    });
const getInvoiceSettings = ()=>axios.get("/invoice/settings/details");
const deleteInvoice = (invoiceId)=>axios.delete("/invoice/delete/".concat(invoiceId));
const editInvoice = (invoiceId)=>axios.put("/invoice/edit/".concat(invoiceId));
const cancelInvoice = (invoiceId, payload)=>axios.put("/invoice/cancel/".concat(invoiceId), payload);
const addPayment = (payload, invoiceId)=>axios.put("/invoice/payment/".concat(invoiceId), payload);
const addReminder = (payload, invoiceId)=>axios.post("/invoice/reminder/".concat(invoiceId), payload);
const addCredit = (payload, invoiceId)=>axios.post("/invoice/credit/".concat(invoiceId), payload);
const addInvoiceDetail = (invoiceId)=>axios.put("/invoice/sent/".concat(invoiceId));
const copyInvoice = (invoiceId)=>axios.post("/invoice/copy/".concat(invoiceId));
const updateInvoiceSettings = (payload)=>axios.post("/invoice/settings/create", payload);
const generateXmlInvoice = function(invoiceId) {
    let format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cii";
    return axios.post("/invoice/generate-xml/".concat(invoiceId), {
        format
    }, {
        responseType: "blob"
    });
};
const uploadPdfArtifact = (invoiceId, file)=>{
    const payload = new FormData();
    // If it's a Blob, provide a filename so multer sees it as a file upload.
    if (file instanceof File) {
        payload.append("file", file);
    } else {
        payload.append("file", file, "invoice.pdf");
    }
    // Do NOT manually set Content-Type; axios will set the correct multipart boundary.
    return axios.put("/invoice/".concat(invoiceId, "/artifacts/pdf"), payload);
};
const uploadCreditPdfArtifact = (creditId, file)=>{
    const payload = new FormData();
    if (file instanceof File) {
        payload.append("file", file);
    } else {
        payload.append("file", file, "credit-note.pdf");
    }
    return axios.put("/invoice/credit/".concat(creditId, "/artifacts/pdf"), payload);
};
const uploadReminderPdfArtifact = (reminderId, file)=>{
    const payload = new FormData();
    if (file instanceof File) {
        payload.append("file", file);
    } else {
        payload.append("file", file, "reminder.pdf");
    }
    return axios.put("/invoice/reminder/".concat(reminderId, "/artifacts/pdf"), payload);
};
const finalizeInvoice = (invoiceId)=>axios.post("/invoice/".concat(invoiceId, "/finalize"));
const finalizeCredit = (creditId)=>axios.post("/invoice/credit/".concat(creditId, "/finalize"));
const finalizeReminder = (reminderId)=>axios.post("/invoice/reminder/".concat(reminderId, "/finalize"));
const downloadInvoiceArtifact = (invoiceId, format)=>axios.get("/invoice/".concat(invoiceId, "/artifacts"), {
        params: {
            format
        },
        responseType: "blob"
    });
const downloadCreditArtifact = (creditId, format)=>axios.get("/invoice/credit/".concat(creditId, "/artifacts"), {
        params: {
            format
        },
        responseType: "blob"
    });
const downloadReminderArtifact = (reminderId, format)=>axios.get("/invoice/reminder/".concat(reminderId, "/artifacts"), {
        params: {
            format
        },
        responseType: "blob"
    });
export const InvoiceApis = {
    draftInvoice,
    getInvoiceDetails,
    getInvoices,
    getInvoiceSettings,
    deleteInvoice,
    editInvoice,
    addPayment,
    cancelInvoice,
    addInvoiceDetail,
    copyInvoice,
    addReminder,
    addCredit,
    updateInvoiceSettings,
    generateXmlInvoice,
    uploadPdfArtifact,
    uploadCreditPdfArtifact,
    uploadReminderPdfArtifact,
    finalizeInvoice,
    finalizeCredit,
    finalizeReminder,
    downloadInvoiceArtifact,
    downloadCreditArtifact,
    downloadReminderArtifact
};
